export const GET_QUEUES = 'GET_QUEUES'
